import { useTranslation } from 'react-i18next';
import ToggleInput from '../../components/Inputs/ToggleInput';
import { handleToggleLanguages } from '../../i18n';

export default function ForeignerContent(
    { handleToggle }: { handleToggle?: (isNotDefault: boolean) => void }
) {
    const { t, i18n } = useTranslation();
    return (
        <div className="foreigner-wrapper">
            <ToggleInput
                onChange={ handleToggle
                    ? handleToggle
                    : handleToggleLanguages
                }
                defaultValue={i18n.language !== 'pt'}
            />
            <p>{t('auth.foreigner_wrapper')}</p>
        </div>
    );
}
